var _module_exports = "<div class='pr-widget-body'></div>\n";;
var path = '/app/src/client/components/widget/widget-body/widget-body.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;